import React from "react";
import ItemEmployee from "./ItemEmployee";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import RolesState from "../../api/RolesState";
import Msg from "../../api/Msg";
import { ContainerSubTitleGrey } from "../ContainerSubTitleGrey";
import { BtnSearch } from "../tools/BtnSearch";

const GRID_CLASS = "cc-v4-soft-grid employees-list-grid";

const EMPTY_NO_DATA = "В базе нет активных сотрудников";
const EMPTY_SEARCH =
  "Не найдено сотрудников, удовлетворяющих запросу. Проверьте фамилию, имя, email или телефон.";

const ListEmploees = observer(
  ({ users, search, setSearch, hasActiveEmployees, searchActive }) => {
    const hendlerEmployeeCardError = () => {
      Msg.writeMessages(
        "У вас нет прав доступа, чтобы просматривать карточки сотрудников",
      );
    };

    const activeUsers = users ?? [];

    const rowClass = `cc-v4-soft-row ${GRID_CLASS} reports-soft-row employees-list-row`;

    const emptyText = !hasActiveEmployees
      ? EMPTY_NO_DATA
      : searchActive
        ? EMPTY_SEARCH
        : EMPTY_NO_DATA;

    return (
      <section
        className="card dash-card employees-list-panel"
        aria-label="Сотрудники"
      >
        <div className="reports-toolbar company-list-toolbar employees-list-toolbar">
          <BtnSearch
            placeholder="Поиск по фамилии, имени, email и телефону…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="reports-search-input"
          />
        </div>
        <div className="cc-v4-soft-list-root">
          <div className={`cc-v4-soft-header ${GRID_CLASS}`}>
            <span className="cc-v4-soft-th-static">
              <span className="cc-v4-soft-th-label">Фамилия</span>
            </span>
            <span className="cc-v4-soft-th-static">
              <span className="cc-v4-soft-th-label">Имя</span>
            </span>
            <span className="cc-v4-soft-th-static employees-list-col-patronymic">
              <span className="cc-v4-soft-th-label">Отчество</span>
            </span>
            <span className="cc-v4-soft-th-static employees-list-col-email">
              <span className="cc-v4-soft-th-label">Email</span>
            </span>
            <span className="cc-v4-soft-th-static employees-list-col-phone">
              <span className="cc-v4-soft-th-label">Телефон</span>
            </span>
            <span className="cc-v4-soft-th-static employees-list-col-role">
              <span className="cc-v4-soft-th-label">Роль</span>
            </span>
          </div>
          <div className="cc-v4-soft-body employees-list-body">
            {activeUsers.length > 0 ? (
              activeUsers.map((employee) => (
                <div key={employee.id} className={rowClass}>
                  {RolesState.emploee_id ? (
                    <Link
                      to={`/employees/${employee.id}`}
                      className="employees-list-link-contents"
                    >
                      <ItemEmployee employee={employee} />
                    </Link>
                  ) : (
                    <div
                      role="button"
                      tabIndex={0}
                      className="employees-list-link-contents"
                      onClick={hendlerEmployeeCardError}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          hendlerEmployeeCardError();
                        }
                      }}
                    >
                      <ItemEmployee employee={employee} />
                    </div>
                  )}
                </div>
              ))
            ) : (
              <ContainerSubTitleGrey text={emptyText} />
            )}
          </div>
        </div>
      </section>
    );
  },
);

export default ListEmploees;
